// Base URL for links that LEAVE this machine — QR codes, copied links, anything
// a prospect's phone has to resolve.
//
// window.location.origin is wrong for these: if an admin is browsing on
// http://localhost:3006, the QR encodes "localhost", and a phone scanning it
// looks for a server on ITSELF and fails. Same trap with 127.0.0.1.
//
// Set REACT_APP_PUBLIC_URL in .env to your LAN IP (testing) or your real domain
// (production) and every shared link uses it. Restart `npm start` after editing.
//   REACT_APP_PUBLIC_URL=http://192.168.29.25:3006
//   REACT_APP_PUBLIC_URL=https://cards.dfcindia.in
const LOOPBACK = /^(localhost|127\.0\.0\.1|\[::1\]|0\.0\.0\.0)$/i;

export function publicOrigin() {
  const configured = (process.env.REACT_APP_PUBLIC_URL || '').trim().replace(/\/+$/, '');
  if (configured) return configured;
  return window.location.origin;
}

// True when a shared link would point at the scanner's own device — i.e. useless
// on a phone. Screens that hand out links use this to warn instead of failing silently.
export function isLoopback() {
  try { return LOOPBACK.test(new URL(publicOrigin()).hostname); } catch { return false; }
}

export const publicUrl = (path) => `${publicOrigin()}${path.startsWith('/') ? path : '/' + path}`;
